<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑文章"></el-page-header>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="文章标题" prop="article_title">
                <el-input type="text" v-model="ruleForm.article_title" placeholder="请输入文章标题" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="文章所属" prop="article_title">
                <el-input type="text" v-model="ruleForm.article_type" placeholder="请输入文章归属" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>


            <el-form-item label="内容" prop="article_content" style="margin:0px 0px 130px 0px;">
                <div>(如需上传,请选择小于5M的图片)</div>
                <me-wang-editor v-model="ruleForm.article_content"></me-wang-editor>

            </el-form-item>

            <!-- form表单提交 -->
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {getFormatDate} from "@/utils/date";
import {check} from "@/utils/checkData";
import {isMobile} from "@/api/order";


export default {
    props: {
        /*编辑器的内容*/
        value: {
            type: String
        },
        /*图片大小*/
        maxSize: {
            type: Number,
            default: 5120 //kb
        }
    },
    computed: {},
    created() {
        if (isMobile()) {
            this.form_width = "100%"
        }
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getDetails();
    },
    data() {
        return {
            id: "",
            type: "",
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            ruleForm: {
                article_title: "",
                article_content: "",
                article_type: "",
            },
            rules: {
                article_title: [
                    {required: true, message: "请输入文章标题", trigger: "blur"},
                ],
                article_type: [
                    {required: true, message: "请输入文章归属", trigger: "blur"},
                ],
                article_content: [
                    {required: true, message: "请输入内容", trigger: "blur"},
                ],
            },
            form_width: "40%",
        };
    },
    methods: {

        // 返回上一页
        goBack() {
            window.history.go(-1);
        },

        // 获取详情
        getDetails() {
            let news_params = {
                servername: "Ruyi_ContentServices",
                method: "articleDetail",
                params: {
                    id: this.id
                }
            };

            this.$api.service(news_params).then(res => {
                if (!check(res)) {
                    return;
                }
                let content = res.data.data.article_content;

                // 获取文本中的图片地址
                var imgReg = /<img.*?(?:>|\/>)/gi;
                var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
                var allImage = content.match(imgReg);
                if (allImage) {
                    for (var i = 0; i < allImage.length; i++) {
                        var src = allImage[i].match(srcReg);
                        //获取图片地址
                        if (src[1] && src[1].indexOf("http") == -1 && src[1].indexOf("https") == -1) {
                            content = content.replace(new RegExp(src[1], 'g'), this.imgUrl + src[1]);
                        }
                    }
                }

                this.ruleForm['article_title'] = res.data.data.article_title;
                this.ruleForm['article_type'] = res.data.data.article_type;
                this.ruleForm['article_content'] = content;
            });
        },

        // 提交表单
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                // 替换掉图片地址为目录地址
                let content = this.ruleForm.article_content.replace(new RegExp(env.IMG_COMMON_URL_PREFIX, 'g'), "");
                if (valid) {
                    let userData = getUserInfos();
                    let params = {
                        'servername': 'Ruyi_ContentServices',
                        'method': 'articleSave',
                        'params': {
                            type: this.type,
                            article_title: this.ruleForm.article_title,
                            article_type: this.ruleForm.article_type,
                            article_content: content,
                            id: this.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }

                        this.$message({
                            type: "success",
                            message: '编辑成功',
                            duration: 1500,
                            onClose: function () {
                                window.history.go(-1);
                            }
                        });
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    return false;
                }
            });
        },


    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
